/* eslint-disable jsx-a11y/anchor-is-valid */
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {MasiveUploadSite} from '../form/masive'
import {TableSite} from './column'
const TableSiteWrapper = () => {
  const {isAllowed} = useCentral()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Site</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableSite />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadSite />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableSiteWrapper}
